<template>
  <div>
    <div class="flex">
      <input
        :value="quantity"
        class="block text-center focus:outline-none"
        type="number"
        style="width: 72px; border-left: 2px solid #ECEFF1; border-top: 2px solid #ECEFF1; border-bottom: 2px solid #ECEFF1;"
        @input="(event) => {
          if (!isNaN(parseInt(event.target.value))) {
            $emit('update:quantity', parseInt(event.target.value))
          }
        }"
      >
      <sky-btn
        class="bg-sky_secondary text-white border-sky_secondary flex-1 text-center"
        dark
        :loading="loading"
        :disabled="quantity % pcb !== 0"
        @click="$emit('add', quantity)"
      >
        Ajouter au panier
      </sky-btn>
    </div>
    <div v-if="quantity % pcb !== 0" class="text-red-500 mt-5 text-sm">
      Attention, le PCB de ce produit est de {{ pcb }}. Vous devrez avoir un multiple du PCB dans votre panier pour passer la commande.
    </div>
  </div>
</template>

<script>
export default {
  props: {
    quantity: {
      default: 1,
      type: Number
    },
    loading: {
      required: false,
      default: false,
      type: Boolean
    },
    pcb: {
      required: false,
      default: 1,
      type: Number
    }
  }
}
</script>
